import React, { useState, useEffect } from "react";
import { API_BASE_URL, WEBSOCKET_URL } from "../utils/apiConfig";
import styled from "styled-components";
import io from "socket.io-client";
import { useParams } from "react-router-dom";
import { useUserContext } from "../context/user_context";
import { useHistory } from "react-router-dom";
import { Winner } from "../components/Winner";
import Modal from "../components/Modal";
import { UserInfo, GroupSubscriberDetailsPopup } from "../components";
import Alert from "../components/Alert";
import backIcon from '../assets/back.png'
import { FaEdit, FaTrash } from 'react-icons/fa';
import { useGroupDetailsContext } from '../context/group_context';


const AuctionsPage = () => {

    const [signedUrls, setSignedUrls] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const history = useHistory();
    const { isLoggedIn, user } = useUserContext();

    const { state: groupDetailsState } = useGroupDetailsContext();
    const { data: groupsAccountsDetail } = groupDetailsState;
  

    const [list, setList] = useState([]);
    const { groupId, nextAuctionDate } = useParams();
    const [isAuctionOpen, setIsAuctionOpen] = useState(false);
    const [bidAmount, setBidAmount] = useState("");
    const [socket, setSocket] = useState(null);
    const [auctionId, setAuctionId] = useState(null);
    const [bidList, setBidList] = useState([]); // State to store the list of bids
    const [existingOpenAuction, setExistingOpenAuction] = useState(null); // State to store existing open auction ID
    const [isSubscriberDetailsOpen, setIsSubscriberDetailsOpen] = useState(false);

    const [isexistAucModalOpen, setIsexistAucModalOpen] = useState(false);
    // For auction Modal change
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [alert, setAlert] = useState({ show: false, msg: "", type: "" });

    const [selectedSubscriberidForBid, setSelectedSubscriberIdForBid] = useState(null);
    const [selectedgrpSubscriberidForBid, setSelectedgrpSubscriberIdForBid] = useState(null);
    const [selectedSubscriberimageForBid, setSelectedSubscriberImageForBid] = useState(null);
    const [selectedSubscribername, setSelectedSubscribername] = useState(null);
    const [selectedSubscriberphone, setSelectedSubscriberphone] = useState(null);


    // if its fixed take auction amount and put in text box
    useEffect(() => {
        if (groupsAccountsDetail?.results?.type === 'FIXED') {
          const pendingAuctions = groupsAccountsDetail.results.groupAccountResult
            ?.filter(item => item.auctionStatus === 'pending')
            .sort((a, b) => a.sno - b.sno);
    
          if (pendingAuctions && pendingAuctions.length > 0) {
            const firstAuctionAmount = pendingAuctions[0]?.auctionAmount;
            setBidAmount(firstAuctionAmount?.toString() || '');
          }
        }
      }, [groupsAccountsDetail]);

    // const [auctDate, setAuctDate] = useState(() => {
    //     // Extract the value of nextAuctionDate from the URL path
    //     const match = window.location.pathname.match(/\/date\/nextAuctionDate=(\d{4}-\d{2}-\d{2})/);

    //     // If a match is found, extract the date and format it
    //     if (match) {
    //         const nextAuctionDateParam = match[1];
    //         const [year, month, day] = nextAuctionDateParam.split("-");
    //         const date = new Date(year, month - 1, day);
    //         date.setUTCHours(0, 0, 0, 0);

    //         // Check if the date is valid
    //         if (!isNaN(date.getTime())) {
    //             // Format the date as "YYYY-MM-DD"
    //             const formattedDate = date.toISOString().split("T")[0];
    //             return formattedDate;
    //         }
    //     }

    //     // Return an empty string if nextAuctionDate is not available or invalid
    //     console.error("Invalid or missing date parameter in the URL path.");
    //     return "";
    // });

    const [auctDate, setAuctDate] = useState(() => {
        // Extract the value of nextAuctionDate from the URL path
        const match = window.location.pathname.match(/\/date\/nextAuctionDate=(\d{4}-\d{2}-\d{2})/);

        // If a match is found, extract the date
        if (match) {
            const nextAuctionDateParam = match[1];
            return nextAuctionDateParam;
        }
    });


    const [auctionType, setAuctionType] = useState(""); // State for auctionType
    const handleOpenModal = () => {
        setIsModalOpen(true);
    };
    const showAlert = (show = false, type = "", msg = "") => {
        setAlert({ show, type, msg });
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);

    };


    // Below two fucntion for modals  for existing auction 
    const handleOpenExistingAuctModal = () => {
        setIsexistAucModalOpen(true);
    };

    const handleCloseExistingAuctModal = () => {
        setIsexistAucModalOpen(false);
    };
    //
    const handleOpenAuction = () => {
        socket.emit("joinGroup", groupId);

        // Use auctDate and auctionType from state
        socket.emit("openAuction", {
            groupId: groupId,
            userId: user.results.userId,
            sourceSystem: "WEB",
            auctDate: auctDate,
            auctionType: auctionType,
        });

        setIsModalOpen(false); // Close the modal
    };

    // end of modal change

    useEffect(() => {
        // Initialize the WebSocket connection when the component mounts
        const socket = io(WEBSOCKET_URL);
        setSocket(socket);

        // Listen for 'openAuction' event from the server
        socket.on("openAuction", (data) => {
            // You can use the 'auctionId' to join the auction
            console.log(data);
            console.log("Received auction ID:", data.groupAccountId);
            setAuctionId(data.groupAccountId);
            socket.emit("joinAuction", data.groupAccountId);
            setIsAuctionOpen(true);
            // Perform any logic to join the auction using the 'auctionId'
            // Example: socket.emit('joinAuction', auctionId);
        });
        socket.on("openAuctionError", (errorData) => {

            showAlert(true, "danger", errorData.message);
            // Handle the closing of the auction here
            console.log("Open auction  error:", errorData.message);

            // Perform any client-side actions related to the closed auction
        });

        socket.on("newBid", (data) => {
            // Handle the closing of the auction here
            console.log("new bid", data);
            // Add the new bid to the bidList state
            setBidList((prevBidList) => [...prevBidList, data.auctionObject]);
            console.log("new bid", data);

            // Perform any client-side actions related to the closed auction
        });

        // Listen for 'closeAuction' event from the server
        socket.on("closeAuction", (winningSub) => {
            // Handle the closing of the auction here
            console.log(winningSub);
            console.log(winningSub.auctionroomIdentifier);
            socket.emit("leaveAuction", winningSub.auctionroomIdentifier);
            setIsAuctionOpen(false);
            // Clear the bidList by setting it to an empty array
            setBidList([]);
            // Perform any client-side actions related to the closed auction
        });
        socket.on("closeGroup", (winningSub) => {
            // Handle the closing of the auction here
            console.log(winningSub);
            socket.emit("leaveGroup", winningSub.winnerObject.groupRoomIdentifier);
            // history.push(`/groups/${winningSub.winnerObject.groupId}/auctions/winner/${winningSub.winnerObject.reserveAmount}/winner`);
            history.push(`/groups/${winningSub.winnerObject.groupId}/auctions/winner/${winningSub.winnerObject.winnerAmount}/winner`, {
                winningSub: winningSub
            });
            // setIsAuctionOpen(false);
            // Clear the bidList by setting it to an empty array
            //setBidList([]);
            // Perform any client-side actions related to the closed auction
        });
        socket.on("closeAuctionError", (errorData) => {
            // Handle the closing of the auction here
            console.log("Auction close error:", errorData.message);
            setIsAuctionOpen(false);
            setExistingOpenAuction(null);
            // Perform any client-side actions related to the closed auction
        });

        socket.on("bidError", (errorData) => {
            // Handle the closing of the auction here

            showAlert(true, "danger", errorData.message);
            console.log("PlaceBidError:", errorData);

            // Perform any client-side actions related to the closed auction
        });
        socket.on("existsAuction", (existsAuctionId) => {
            // Handle the closing of the auction here
            console.log("Existing open auction ID:", existsAuctionId);
            // Set the existing open auction ID in the state
            setExistingOpenAuction(existsAuctionId);
            setAuctionId(existsAuctionId);
            setIsAuctionOpen(false);
            // Open the new modal when existsAuction is triggered
            setIsexistAucModalOpen(true);
            // Perform any client-side actions related to the closed auction
        });

        // Listen for 'existingBids' event from the server
        socket.on("existingBids", (existingBids) => {
            // Update the bidList state with the existing bid data
            // Update bidList with existing bids using the spread operator
            setBidList((prevBidList) => [...prevBidList, ...existingBids]);



            setIsAuctionOpen(true);
        });

        // Cleanup the socket when the component unmounts
        return () => {
            if (socket) {
                socket.disconnect();
            }
        };
    }, []);

    const handleCloseExistingAuction = () => {
        // Perform the logic to close the existing open auction
        console.log("Close existing open auction:", existingOpenAuction);

        // You can emit a socket event to the server to close the auction if needed
        socket.emit("closeAuction", {
            groupId: groupId,
            userId: user.results.userId,
            sourceSystem: "web",
            groupCollectedBy: groupId,
            groupAccountId: existingOpenAuction,
        });



        // Clear the existing open auction from state
        setExistingOpenAuction(null);
    };

    const handleResumeExistingAuction = () => {
        // Perform the logic resume the auction
        socket.emit("getPrevBids", existingOpenAuction);

        socket.emit("joinGroup", groupId);
        socket.emit("joinAuction", existingOpenAuction);

        console.log("start existingOpenAuction");
        console.log(existingOpenAuction);

        console.log("end existingOpenAuction");
        setIsAuctionOpen(true);
        setIsModalOpen(false);
        setIsexistAucModalOpen(false);


    };

    const toggleAuction = () => {
        console.log("came to close");
        if (isAuctionOpen) {


            setSelectedSubscriberIdForBid(null);
            setSelectedgrpSubscriberIdForBid(null);
            setSelectedSubscribername(null);
            setSelectedSubscriberphone(null);

            // Perform database operations for closing the auction
            console.log(auctionId);
            socket.emit("joinAuction", auctionId);
            socket.emit("closeAuction", {
                groupId: groupId,
                userId: user.results.userId,
                sourceSystem: "WEB",
                groupCollectedBy: groupId,
                groupAccountId: auctionId,
            });
        } else if (!isAuctionOpen) {
            console.log("came from open auction");
            setIsModalOpen(true); // Open the modal for user input
            // socket.emit("joinGroup", groupId); // Join the auction room
            // socket.emit("openAuction", {
            //     groupId: groupId,
            //     userId: user.results.userId,
            //     sourceSystem: "WEB",
            //     auctDate: "2023-12-20"
            // });
        }
    };

    const openSubscriberDetails = () => {
        setIsSubscriberDetailsOpen(true);
    };

    const closeRightside = () => {
        setIsSubscriberDetailsOpen(false);
    }

    const closeSubscriberDetails = (grpSubscriberId, subscriberImage, name, phone, id) => {

        if (grpSubscriberId) {
            setSelectedSubscriberIdForBid(id !== undefined ? id : null);
            setSelectedgrpSubscriberIdForBid(grpSubscriberId !== undefined ? grpSubscriberId : null);
            setSelectedSubscriberImageForBid(subscriberImage !== undefined ? subscriberImage : null);
            setSelectedSubscribername(name !== undefined ? name : null);
            setSelectedSubscriberphone(phone !== undefined ? phone : null);
        }



        setIsSubscriberDetailsOpen(false);



    };

    const handlePlaceBid = (e) => {
        console.log(selectedgrpSubscriberidForBid);

        if (selectedgrpSubscriberidForBid) {
            console.log("Placing bid with amount:", bidAmount);

            console.log("from auctions", selectedgrpSubscriberidForBid);

            // Open the popup with subscriber details


            // Use selectedBidId as grpUserId
            socket.emit("placeBid", {
                groupId: groupId,
                subscriberId: selectedSubscriberidForBid,
                grpSubscriberId: selectedgrpSubscriberidForBid,
                grpUserId: user.results.userId, // Use selectedBidId as grpUserId
                sourceSystem: "WEB",
                auctDate: "2023-12-20",
                amount: bidAmount,
                groupAccountId: auctionId,
            });

            // You can send the bid to the server or perform any other actions as needed.
        } else {
            // Update state to show an alert when selectedBidId is not available
            showAlert(true, "danger", "Subscriber is not selected to Bid.");
            openSubscriberDetails();
            // You can show an alert or perform other error handling actions.
        }
    };
    const handleBackButtonClick = () => {
        socket.emit("leaveGroup", groupId);
        history.push(`/groups/${groupId}`);
    };
    const closeSubscriberList = () => {
        // Reset the values and close the div
        setSelectedgrpSubscriberIdForBid(null);
        setSelectedSubscriberImageForBid(null);
        setSelectedSubscribername(null);
        setSelectedSubscriberphone(null);
        setSelectedSubscriberIdForBid(null);


        // You may also want to reset other state values here

        // Additional logic if needed...
    };

  

    


    return (
        <Wrapper className="section-center">
            <section className="container" style={{ position: "relative" }}>
                {isModalOpen && (
                    <Modal isOpen={handleOpenModal} onClose={handleCloseModal}>
                        <h3 className="popup-header-text">Open Auction</h3>
                        <div style={{ marginTop: "20px" }}>
                            Auction Date :
                            <input type="date" value={auctDate} onChange={(e) => setAuctDate(e.target.value)} style={{ margin: "0 16px" }} />
                        </div>
                        <div style={{ marginTop: "10px" }}>
                            Auction Type :
                            <input type="radio" name="auctionType" value="Normal Auction" checked={auctionType === "NORMALAUCTION"} onChange={() => setAuctionType("NORMALAUCTION")} style={{ margin: "0 4px 0 16px" }} />
                            Normal Auction
                            <input type="radio" name="auctionType" value="Profit Auction" checked={auctionType === "PROFITAUCTION"} onChange={() => setAuctionType("PROFITAUCTION")} style={{ margin: "0 4px 0 16px" }} />
                            Profit Auction

                            <input type="radio" name="companyChit" value="Company Chit" checked={auctionType === "COMPANYCHIT"} onChange={() => setAuctionType("COMPANYCHIT")} style={{ margin: "0 4px 0 16px" }} />
                            Company Chit
                        </div>
                        <div>
                            <button className="successBtn" onClick={handleOpenAuction}>
                                Open Auction
                            </button>
                            <button className="cancelBtn" onClick={() => setIsModalOpen(false)}>
                                Cancel
                            </button>
                        </div>
                    </Modal>
                )}
                <span style={{ position: "absolute", left: "20px", top: "18px", background: "transparent", borderRadius: "50%", padding: "5px", boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.5)", zIndex: 1 }}>
                    <button className="" style={{ display: "flex", background: "transparent", border: "unset" }} onClick={handleBackButtonClick}>
                        <img style={{ width: "16px", marginRight: "8px" }} src={backIcon} alt="Back" />
                    </button>
                </span>
                <h3 style={{ marginTop: "12px" }}>Auctions Page</h3>
                {alert.show && <Alert {...alert} removeAlert={showAlert} list={list} />}
                {isAuctionOpen ? (
                    <div className="form-control">

                        {selectedgrpSubscriberidForBid &&
                            (
                                <div className="subscriber-details">
                                    {selectedSubscriberimageForBid ? (
                                        <img src={selectedSubscriberimageForBid} alt={selectedSubscribername}
                                            style={{ width: '50px', height: '50px' }} />
                                    ) : (
                                        <img src="default-image.jpg" alt={selectedSubscribername} style={{ width: '50px', height: '50px' }} />
                                    )}
                                    <p>{selectedSubscribername}</p>
                                    <button onClick={openSubscriberDetails} type="submit" className="btn">
                                        Subscribers List
                                    </button>
                                    <button onClick={closeSubscriberList} className="close-btnlist">
                                        X
                                    </button>
                                </div>
                            )}
                        <div className="row">
                            <input type="text" className="subcriber" placeholder="Enter bid amount" value={bidAmount} onChange={(e) => setBidAmount(e.target.value)} />
                            <button onClick={handlePlaceBid} type="submit" className="submit-btn">
                                Place Bid
                            </button>
                            <button onClick={toggleAuction} type="submit" className="close-btn">
                                Close Auction
                            </button>
                        </div>
                    </div>

                ) : (
                    <button onClick={toggleAuction} type="submit" style={{ width: "180px" }} className="buttonStyleGreen">
                        Open Auction
                    </button>
                )}

                {/* Display the existing open auction if available */}
                {isexistAucModalOpen && (
                    <Modal isOpen={handleOpenExistingAuctModal} onClose={handleCloseExistingAuctModal}>
                        <div>
                            <p>Existing open auction ID: {existingOpenAuction}</p>
                            {/* Add a close button to close the existing open auction */}
                            <button className="cancelBtn"
                                onClick={handleCloseExistingAuction}>Close Auction</button>
                            <button className="successBtn" onClick={handleResumeExistingAuction}>Resume Auction</button>
                        </div>
                    </Modal>
                )}
                {/* Render the SubscriberDetailsPopup when isSubscriberDetailsOpen is true */}
                {isSubscriberDetailsOpen && (
                    <GroupSubscriberDetailsPopup onClose={closeSubscriberDetails}
                        onCloseRightSide={closeRightside}

                    />
                )}

                {/* Display the list of bids */}
                {bidList && bidList.length > 0 ? (


                    <div>
                        <div className="subcriber-container" >
                            <h3>Bid List</h3>
                            <div className="subscriber-list">
                                {bidList
                                    .slice()
                                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                                    .map((item, index) => {
                                        console.log('Bid List');
                                        console.log(item);
                                        const { firstname, name, phone, user_image,user_image_from_s3, amount, created_at } = item;

                                        // Convert created_at to a Date object
                                        const createdAtDate = new Date(created_at);

                                        // Format time in HH:mm:ss format
                                        const formattedTime = createdAtDate.toLocaleTimeString([], {
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            second: '2-digit',
                                        });

                                        return (
                                            <article className="bidsubscriber-item" key={index}>
                                                   <img
                            src={user_image_from_s3}
                            alt={user_image ? name : "Default profile image"}
                            onError={(e) => (e.target.src = "default-image.jpg")}
                        />

                                                <p className="title">{formattedTime}</p>
                                                <p className="title">{name || firstname}</p>
                                                <p className="title">{amount}</p>
                                            </article>
                                        );
                                    })}
                            </div>

                        </div>
                    </div>
                ) : (
                    <div></div>
                )}
            </section>
        </Wrapper>
    );
};
const Wrapper = styled.section`
overflow: auto;    
 .container {
   
        display:flex;   
         flex-direction: column;     
        width: 90vw;       
        margin: 0 auto;
        max-width: 40rem;
        margin-top: 2rem;
        margin-bottom: 4rem;
        background: var(--clr-white);
        border-radius: var(--radius);
        box-shadow: var(--light-shadow);
        transition: var(--transition);
        padding: 2rem;     
        flex-grow: 1;        
     
    }
    .container:hover {
        box-shadow: var(--dark-shadow);
    }
    .form-control {
        display: flex;
        justify-content: center;
        flex-direction: column; 
        align-items: center;              
    }
    .row {
        display: flex;
        justify-content: center;        
        flex-direction: row;               
    }
    .subcriber {
        padding: 0.25rem;
        padding-left: 1rem;
        background: var(--clr-grey-10);
        border-top-left-radius: var(--radius);
        border-bottom-left-radius: var(--radius);
        border-color: transparent;
        font-size: 1rem;
        flex: 1 0 auto;
        color: var(--clr-grey-5);
    }
    @media screen and (max-width: 500px) {
        .subcriber {
            width: 60%; /* Adjust the width as needed */
            
        }
        
        .submit-btn,
        .close-btn {
            width: 30%; /* Adjust the width of buttons as needed */
        }
    }
    

    .subcriber::placeholder {
        font-family: var(--ff-secondary);
        color: var(--clr-grey-5);
    }
    .submit-btn {
        background: var(--clr-red-dark);
        border-color: transparent;
        flex: 0 0 5rem;
        display: grid;
        align-items: center;
        text-transform: capitalize;
        letter-spacing: 2px;
        border-top-right-radius: var(--radius);
        border-bottom-right-radius: var(--radius);
        cursor: pointer;
        content: var(--clr-primary-5);
        transition: var(--transition);
        font-size: 0.85rem;
    }
    .close-btn {
        background: var(--clr-red-dark);
        border-color: transparent;
        flex: 0 0 5rem;
        display: grid;
        align-items: center;
        text-transform: capitalize;
        letter-spacing: 2px;
        border-top-right-radius: var(--radius);
        border-bottom-right-radius: var(--radius);
        border-top-left-radius: var(--radius);
        border-bottom-left-radius: var(--radius);
        cursor: pointer;
        content: var(--clr-primary-5);
        transition: var(--transition);
        font-size: 0.85rem;
    }
    .open-btn {
        background: var(--clr-red-dark);
        border-color: transparent;
        width: 10rem;
        flex: 0 0 2rem;
        display: grid;
        align-items: center;
        text-transform: capitalize;
        letter-spacing: 2px;
        border-top-right-radius: var(--radius);
        border-bottom-right-radius: var(--radius);
        border-top-left-radius: var(--radius);
        border-bottom-left-radius: var(--radius);
        cursor: pointer;
        content: var(--clr-primary-5);
        transition: var(--transition);
        font-size: 0.85rem;
    }

    .submit-btn:hover {
        background: var(--clr-primary-5);
        color: var(--clr-white);
    }
    .subcriber-container {
        margin-top: 2rem;  
     background-color: #ffffff;
     border-radius: 10px;
     padding: 15px;
     box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
     text-align: center;
     margin: 10px;
     width:400px;
     
    }
    .bidsubscriber-item {
    margin-top:12px;    
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5rem;
    transition: var(--transition);
    padding: 0.25rem 1rem;
    border-radius: var(--radius);
    text-transform: capitalize;
    img {
      height: 100%;
      width: 45px;
      border-radius: 50%;
      object-fit: cover;
    }
    }

    .subcriber-item:hover {
        color: var(--clr-grey-5);
        background: var(--clr-grey-10);
    }

    .subcriber-item:hover .title {
        color: var(--clr-grey-5);
    }
    .title {
        margin-bottom: 0;
        color: var(--clr-grey-1);
        letter-spacing: 2px;
        transition: var(--transition);
        padding: 10px;
    }

    @media (min-width: 992px) {
        height: calc(100vh - 5rem);
    }
    .header {
        display: grid;
        backgroud-color: red;
        grid-template-columns: 1fr 1fr; /* Two equal fractions */
        align-items: left; /* Center content vertically */
        padding: 10px; /* Adjust the padding as needed */
    }
    .back-button {
        background: var(--clr-primary-1); /* Use the appropriate background color */
        color: var(--clr-white); /* Use the appropriate text color */
        border: none;
        border-radius: var(--radius);
        padding: 0.5rem 1rem;
        cursor: pointer;
        font-size: 1rem;
        transition: background 0.2s;
        justify-self: start;

        &:hover {
            background: var(--clr-primary-5); /* Change color on hover to match your theme */
        }
    }
    h3 {
        /* Apply the same style as the back button */
        justify-self: start;
        /* Add any additional styles for the heading as needed */
    }
.subscriber-details{
    position:relative;
    display:flex;
    justify-content: center;
        flex-direction: column; 
        align-items: center;
        margin-bottom:1rem;
}
.close-btnlist{
    position: absolute;
    top: 10px; /* Adjust the top value based on your layout */
    right: 10px; /* Adjust the right value based on your layout */
    background-color: var(--clr-red-dark);
    color: #ffffff; /* Choose your desired text color */
    padding: 8px 12px;
    border: none;
    cursor: pointer;
    border-radius: 5px;
  }
  
  .close-btnlist:hover {
    background-color: #cc0000; /* Choose a different color on hover if desired */
  }

`;
export default AuctionsPage;
